module.exports = __webpack_public_path__ + "static/circle-overline-icon.0d4475f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/circle-overline-icon.svg
// module id = 362
// module chunks = 168707334958949